import { render, staticRenderFns } from "./mButton.vue?vue&type=template&id=36d23c6e&scoped=true"
import script from "./mButton.vue?vue&type=script&lang=js"
export * from "./mButton.vue?vue&type=script&lang=js"
import style0 from "./mButton.vue?vue&type=style&index=0&id=36d23c6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d23c6e",
  null
  
)

export default component.exports